<template>
    <v-container pa-0>
        <v-card class="px-2 pt-2 pb-6 mt-3" flat tile>
            <div class="d-flex flex-row align-center mb-2">
                <back-button :fallback-route="fallbackBackButtonRoute" />
            </div>
            <error-list :errors="errors"></error-list>
            <v-card-title class="headline font-weight-bold pa-2">{{
                $vuetify.lang.t('$vuetify.profile.title')
            }}</v-card-title>
            <build-form
                :form-items="items"
                :actions="actions"
                :rules="rules"
                :form.sync="form"
                ref="form"
                class="px-2"
            />
        </v-card>
    </v-container>
</template>
<script>
// 3rd
import { mapActions, mapState } from 'vuex';
// models
import User from '../../models/User';
// components
import BuildForm from '../../components/Builders/BuildForm';
import BackButton from '../../components/BackButton';
import ErrorList from '../../components/ErrorList';
// utils
import { ROUTE_PROFILE } from '../../utils/constants';
import {
    terms_and_conditions,
    email_taxation_documentation
} from '../../utils/formRules';
import {
    redirect,
    transformArrayToSelectValues,
    setPageTitle
} from '../../utils/helper';

export default {
    name: 'change-data',
    components: {
        BuildForm,
        BackButton,
        ErrorList
    },
    data() {
        return {
            prefilled: false,
            errors: {},
            form: {
                terms_and_conditions: false,
                email_taxation_documentation: ''
            },
            rules: {
                terms_and_conditions,
                email_taxation_documentation
            }
        };
    },
    computed: {
        ...mapState(['genders', 'employmentTypes', 'countryCodes']),
        salutations() {
            return transformArrayToSelectValues(
                this.genders,
                '$vuetify.salutation.'
            );
        },
        employment_types() {
            return transformArrayToSelectValues(
                this.employmentTypes,
                '$vuetify.employment_type.'
            );
        },
        country_codes() {
            return transformArrayToSelectValues(this.countryCodes, '');
        },
        items() {
            return [
                {
                    is: 'subhead',
                    name: 'privateSection',
                    label: '$vuetify.profile.company_data',
                    classes: 'mx-2 mb-2'
                },
                {
                    is: 'text',
                    name: 'email_taxation_documentation'
                },
                {
                    is: 'checkbox',
                    label:
                        '$vuetify.form_items.data_protection_and_conditions_of_participation',
                    linkName: '$vuetify.form_items.data_protection_link',
                    linkName2: '$vuetify.form_items.terms_link',
                    slug: 'data_protection',
                    slug2: 'terms',
                    tooltip: '$vuetify.tooltips.new_window',
                    name: 'terms_and_conditions',
                    readonly: !!this.currentUser.terms_and_conditions
                }
            ];
        },
        actions() {
            return [
                {
                    is: 'button',
                    name: 'save',
                    color: 'primary',
                    clickMethod: this.submit
                }
            ];
        },
        fallbackBackButtonRoute() {
            return { name: ROUTE_PROFILE };
        },
        currentUser() {
            return User.getCurrent();
        }
    },
    methods: {
        ...mapActions(['setSnackbar']),
        prefillForm() {
            this.form.terms_and_conditions = !!this.currentUser
                .terms_and_conditions;
            this.form.email_taxation_documentation = this.currentUser.company.email_taxation_documentation;
        },
        async submit() {
            let result = null;
            try {
                result = await User.submitChangeCompanyData(this.form);
            } catch (e) {
                this.errors =
                    e.response && e.response.data && e.response.data.error
                        ? e.response.data.error
                        : {};
                return;
            }

            this.setSnackbar({
                positionX: 'left',
                type: 'success',
                translatedText: result.data.message,
                time: 10000
            });

            redirect(ROUTE_PROFILE);
        }
    },
    watch: {
        currentUser() {
            if (!this.prefilled) {
                this.prefillForm();
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.currentUser) {
                this.prefillForm();
            }
        });
    }
};
</script>
